import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import BackPage from "../components/BackPage";
import InputSearch from "../components/InputSearch";
import CardThumb from "../components/CardThumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import ScrollTop from "../components/ScrollTop";
import CardSearch from "../components/CardSearch";
import { Loading } from "common/pages";
import { useNavigate } from "react-router-dom";

import "./Search.scss";

export default function Search({ account, setAccount, api }) {
  
  const navigate = useNavigate()
  
  const [loading, setLoading] = useState(true);

  const [searchParam] = useSearchParams();
  const search = searchParam.get("search");

  const [limitContent, setLimitContent] = useState(4);

  const [cards, setCards] = useState([]);
  const [dataSize, setDataSize] = useState(1)
  const [recentlyAddedCards, setRecentlyAddedCards] = useState([]);

  const callbackFavorite = {
    favorited: (cardId) => {
      setRecentlyAddedCards(prev => {
        return prev.map((cardItem) => {
          if (cardItem.id === cardId) cardItem.favorited = true
          return cardItem
        })
      })
      setCards(prev => {
        return prev.map((cardItem) => {
          if (cardItem.id === cardId) cardItem.favorited = true
          return cardItem
        })
      })

      setAccount({ ...account, favorite_count: account.favorite_count + 1 })
    },
    unFavorited: (cardId) => {
      setRecentlyAddedCards(prev => {
        return prev.map((cardItem) => {
          if (cardItem.id === cardId) cardItem.favorited = false
          return cardItem
        })
      })
      setCards(prev => {
        return prev.map((cardItem) => {
          if (cardItem.id === cardId) cardItem.favorited = false
          return cardItem
        })
      })

      setAccount({ ...account, favorite_count: account.favorite_count - 1 })
    },
  }

  useEffect(() => {
    setLoading(true);

    if (!search) {
      navigate("/");
      return;
    }

    const searchLower = search.trim().toLowerCase();

    api(
      `api/providers/${process.env.REACT_APP_SLUG}/content-videos/?search=${searchLower}&page=1&page_size=${limitContent}`,
    ).then(({ ok, body }) => {
      if (ok) {
        setCards(body.data);
        setDataSize(body.data_size)
      }
      setLoading(false);
    });

    api(
      `api/providers/${process.env.REACT_APP_SLUG}/content-videos/?order=updated_at&page_size=4`,
    ).then(({ ok, body }) => {
      if (ok) setRecentlyAddedCards(body.data);
      setLoading(false);
    });
  }, [api, setLoading, setCards, search, navigate, setRecentlyAddedCards, limitContent]);

  return (
    <div className={`search-page wrapper-login ${loading ? "loading" : ""}`}>
      {!loading ? (
        <>
          <div className="bw-event-container">
            <BackPage />
            <div className="wrapper-title">
              <h2 className="bw-event-title">Search results:</h2>
              <InputSearch />
            </div>
            <div className="wrapper-results mb-4">
              {cards.length ? (
                <div className="bw-event-row pt-4">
                  {cards.slice(0, limitContent).map((item, key) => (
                    <div className="bw-event-col" key={key}>
                      <CardSearch api={api} showFavoriteIcon={!!account} card={item} callbackFavorite={callbackFavorite} />
                    </div>
                  ))}
                </div>
              ) : (
                <p className="message py-5">
                  We couldn't find any results for <strong>"{search}"</strong>.
                  Please, give it another try with a different search term
                </p>
              )}

              {limitContent < dataSize ? (
                <button
                  className="bw-event-btn bw-event-btn-more"
                  onClick={() => setLimitContent(limitContent + 3)}
                >
                  Show more
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ color: "#1976D2" }}
                  />
                </button>
              ) : null}
            </div>
          </div>
          {recentlyAddedCards.length ? (
            <section className="recently bw-event-bg-light py-5">
              <div className="bw-event-container">
                <h2 className="bw-event-title">Recently added</h2>
                <div className="bw-event-row pt-4">
                  {recentlyAddedCards.map((item, key) => (
                    <div className="bw-event-col" key={key}>
                      <CardThumb api={api} logged={!!account} card={item} callbackFavorite={callbackFavorite} />
                    </div>
                  ))}
                </div>
              </div>
            </section>
          ) : null}
          <ScrollTop />
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
}
